import React from 'react'

import { customPartners } from '../../constants'
import { AdviceRequest } from '../../interfaces'

interface PartnerViewProps {
  adviceRequest: Partial<AdviceRequest>
  isAdmin?: boolean
}

export const PartnerView = ({ adviceRequest, isAdmin }: PartnerViewProps): JSX.Element | null => {
  const partner =
    adviceRequest.legalProtectionInsurer === 'DEVK'
      ? {
          id: 'devk',
        }
      : adviceRequest.partner

  if (!partner || !partner.id) {
    return null
  }

  const PartnerViewComponent = customPartners[partner.id].view
  return <PartnerViewComponent adviceRequest={adviceRequest} isAdmin={isAdmin} />
}
